import type { CSSProperties } from "react";

/** How many pieces float up the banner. */
export const CONFETTI_COUNT = 14;

/**
 * One piece's place and pace, scattered but the same on every render (no
 * Math.random: a re-render must not reshuffle them, and tests stay stable).
 * welcome.css reads the variables: --x where it starts (% of the banner,
 * right of the text), --t its rise time, --d its delay (negative: already in
 * flight on load), --dx its drift.
 */
export function confettiStyle(i: number): CSSProperties {
	// A small linear congruential step per piece: well spread for 14 indices.
	const r = (k: number) => (((i + 1) * 7919 + k * 104729) % 1000) / 1000;
	return {
		"--x": `${(38 + r(1) * 60).toFixed(1)}%`,
		"--t": `${(6.5 + r(2) * 5).toFixed(2)}s`,
		"--d": `${(-r(3) * 11).toFixed(2)}s`,
		"--dx": `${((r(4) - 0.5) * 3.5).toFixed(2)}rem`,
	} as CSSProperties;
}
